import { Field, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'
import type { MailgunEventTypeEnum } from './MailgunEventTypeEnum'
import { MailgunEventData } from './MailgunWebhook'
import GraphQLJSON from 'graphql-type-json'

@ObjectType()
@InputType('MailgunEventInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class MailgunEvent extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  id: string

  @Field(() => String)
  @Prop({ type: String })
  event: MailgunEventTypeEnum

  @Field(() => Date)
  @Prop({ type: Date })
  timeStamp: Date

  @Field(() => String)
  @Prop({ type: String })
  recipient: string

  @Field(() => String)
  @Prop({ type: String })
  subject?: string

  @Field(() => String)
  @Prop({ type: String })
  bodyPlain?: string

  @Field(() => String)
  @Prop({ type: String })
  bodyHtml?: string

  @Field(() => GraphQLJSON)
  @Prop({ type: MailgunEventData })
  metadata: MailgunEventData
}
